import React from "react";
import PropTypes from "prop-types";

import { Header, Label } from "semantic-ui-react";

import Money from "components/Money";

function SubscriptionSummary({
  status,
  name,
  monthlyPrice,
  billingPeriod,
  currency,
}) {
  const getStatusColor = () => {
    switch (status) {
      case "Cancelled":
      case "Non Renewing":
        return "red";
      case "Active":
        return "green";
      case "Pending Changes":
        return "yellow";
      default:
        return "grey";
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: "18px",
      }}
    >
      <Header data-test="subscription-summary-header" style={{ margin: "0" }}>
        {name ? `${name} Plan ` : ""}
        <Label color={getStatusColor()} style={name ? {} : { marginLeft: "0" }}>
          {status}
        </Label>
      </Header>

      <span data-test="subscription-summary-price">
        <Money currency={currency}>{monthlyPrice}</Money>
        /month {`(billed ${billingPeriod})`}
      </span>
    </div>
  );
}

SubscriptionSummary.propTypes = {
  status: PropTypes.oneOf([
    "Future",
    "Free Trial",
    "Active",
    "Non Renewing",
    "Paused",
    "Cancelled",
    "Pending Changes",
  ]).isRequired,
  name: PropTypes.string,
  monthlyPrice: PropTypes.string.isRequired,
  billingPeriod: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
};

SubscriptionSummary.defaultProps = { name: null };

export default SubscriptionSummary;
